import React from "react"
import NoSubscriptionsCard from "./NoSubscriptionsCard"

const Subscriptions = () => {
  return <NoSubscriptionsCard />
}

export default Subscriptions
